import React, { useCallback, useMemo, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { v4 as uuid } from 'uuid'

import Tooltip from '@material-ui/core/Tooltip'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'

import { getProps } from './utils'

import Table from 'components/table/SimpleTable'
import Window from 'components/dialog/Window'

import HelperText from './HelperText'
import FormDialog from '../Dialog'

import icons from 'icons'

const AddIcon = icons.add
const EditIcon = icons.edit
const DeleteIcon = icons.delete

const useStyles = makeStyles(theme => ({
  root: {
    //padding: theme.spacing(4),
  },
  content: {
    margin: theme.spacing(2),
  },
  titleText: {
    fontWeight: 'bold',
  },
  addButton: {
    marginTop: theme.spacing(2),
  },
  actionButton: {
    margin: theme.spacing(1),
  },
  description: {
    color: '#999'
  },
  helperText: {
    marginTop: theme.spacing(2),
  }
}))

const DEFAULT_FIELDS = [{
  title: 'Name',
  name: 'display_name',
}]

const List = (props) => {

  const classes = useStyles()
  const {
    field: {
      name,
      value,
    },
    form: {
      setFieldValue,
    },
    disabled,
    error,
    touched,
    item,
    onSubmit,
  } = getProps(props)

  const [ deletingItem, setDeletingItem ] = useState(null)
  const [ editingItem, setEditingItem ] = useState(null)

  const getItemName = (item) => item[item.list_display_field] || item.name

  const tableData = useMemo(() => {
    return value
      .map(data => {
        return {
          display_name: getItemName(data),
          ...data
        }
      })
      .map(data => item.list_table_map ? item.list_table_map(data) : data)
  }, [
    value,
    item,
  ])

  const onCancelForm = useCallback(() => setEditingItem(null))
  const onCancelDelete = useCallback(() => setDeletingItem(null))
  const onSubmitForm = useCallback((values) => {
    if(!editingItem.id) {
      values.id = uuid()
      values.createdAt = new Date().toLocaleString()
      setFieldValue(name, value.concat([values]))
    }
    else {
      setFieldValue(name, value.map(item => {
        return item.id == editingItem.id ?
          Object.assign({}, values, {
            id: item.id,
          }) :
          item
      }))
    }
    setEditingItem(null)
  }, [
    editingItem,
    value,
  ])

  const onConfirmDelete = useCallback(() => {
    setFieldValue(name, value.filter(item => item.id != deletingItem.id))
    setDeletingItem(null)
  }, [
    value,
    deletingItem,
  ])

  const tableFields = item.list_table || DEFAULT_FIELDS

  const getActions = useCallback((item) => {
    return (
      <>
        <Tooltip title="Delete">
          <IconButton
            size="small"
            disabled={ disabled }
            onClick={ () => setDeletingItem(item) }
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <Tooltip title="Edit">
          <IconButton
            size="small"
            disabled={ disabled }
            onClick={ () => setEditingItem(item) }
          >
            <EditIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </>
    )
  }, [
    disabled,
  ])

  return (
    <div className={ classes.root }>
      <div className={ classes.title }>
        <Typography gutterBottom variant="subtitle1" className={ classes.titleText }>
          { item.title || item.id }
        </Typography>
      </div>
      <div className={ classes.addButton }>
        <Button
          variant="contained"
          size="small"
          disabled={ disabled }
          onClick={ () => setEditingItem({}) }
        >
          Add { item.list_add_title }&nbsp;<AddIcon />
        </Button>
      </div>
      <div className={ classes.helperText }>
        <HelperText
          helperText={ touched && error ? error : item.helperText }
          error={ error }
          touched={ touched }
        />
      </div>
      <div className={ classes.content }>
        <Table
          hideHeaderIfEmpty
          compact
          withContainer
          actionsTitle=""
          data={ tableData }
          fields={ tableFields }
          getActions={ getActions }
        />
      </div>
      {
        deletingItem && (
          <Window
            open
            withCancel
            title="Confirm delete"
            submitTitle="Delete"
            onCancel={ onCancelDelete }
            onSubmit={ onConfirmDelete }
          >
            <Typography>
              Are you absolutely sure you want to delete { getItemName(deletingItem) }?
            </Typography>
          </Window>
        )
      }
      {
        editingItem && (
          <FormDialog
            withCancel
            size={ item.list_window_size || "md" }
            schema={ item.list_schema }
            initialValues={ editingItem }
            onSubmit={ onSubmitForm }
            onCancel={ onCancelForm }
          />
        )
      }
    </div>
  )
}

export default List